import React from 'react';

import { Link } from '../../Link';

import * as S from '../styles';

export const BlogMenu = () => (
  <S.MenuItems blog>
    <S.MenuItem>
      <Link to="/blog">Início</Link>
    </S.MenuItem>
    <S.MenuItem blog>
      <div className="dropdown">
        <div className="dropdown-button">
          Categorias{' '}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="icon_dropdown" data-name="icon/dropdown" transform="translate(-1308 -64)">
              <path id="container" d="M0 0h24v24H0z" className="cls-1" transform="translate(1308 64)" />
              <path
                id="arrow"
                d="M5 103.141a.681.681 0 0 1-.5-.216L.206 98.4a.765.765 0 0 1 0-1.042.676.676 0 0 1 .99 0l3.8 4 3.8-4a.676.676 0 0 1 .99 0 .765.765 0 0 1 0 1.042l-4.3 4.526a.681.681 0 0 1-.486.215z"
                className="cls-2"
                transform="translate(1314.999 -24.141)"
              />
            </g>
          </svg>
        </div>
        <ul className="dropdown-content">
          <li>
            <Link className="dropdown-item" to="/blog/historias-de-sucesso">
              Histórias de sucesso
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="/blog/e-commerce">
              E-commerce
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="/blog/pagarme-news">
              Pagar.me news
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="/blog/venda-mais">
              Venda mais
            </Link>
          </li>
        </ul>
      </div>
    </S.MenuItem>
    <S.MenuItem blog>
      <Link to="/">Ir para o site</Link>
    </S.MenuItem>
  </S.MenuItems>
);
